import { _isNaN } from "./_setup.js";
import isNumber from "./isNumber.js";
export default function isNaN(obj) {
  return isNumber(obj) && _isNaN(obj);
}
